export default "__VITE_ASSET__BhoV6TPt__"